export const reasonOfDecline = {
  HIGHER_RATES: "Higher Rates",
  SERVICE_ISSUE: "Service issue",
  LATE_SUBMISSION: "Late Submission",
  BENCHMARKING_ONLY: "Benchmarking only",
  SHIPMENT_CANCELED: "Shipment canceled",
  NO_RESPONSE: "No response",
  OTHER: "Other",
  SHIPMENT_POSTPONED: "Shipment postponed",
};
